import React, { useCallback } from 'react';
import classNames from 'classnames';
import CookieManager from "../../Utils/CookieManager";
var css = {
  "widget": "oalp-260Zl",
  "mobile": "oalp-3Z3Jo",
  "imageTitle": "oalp-wZmGt",
  "subtitle": "oalp-2WUtX",
  "title": "oalp-2RgdG",
  "image": "oalp-3F0AM",
  "actionCta": "oalp-1hr3q",
  "desktop": "oalp-ovr99",
  "body": "oalp-38DCD",
  "cta": "oalp-2z3JN"
};
import DependencyManager from "../../DependencyManager";
import StaticItem from "../../Components/StaticItem/StaticItem";
import { withComponentDependency } from "./../../ComponentDependency/withComponentDependency";
import { UNKNOWN } from "../../Constants/locations";
import { compose } from 'redux';
import UserSession from "../../Utils/UserSession";
import { withRouter } from "../../Helpers/withRouter";
import useErrorCookie from "../../CustomHooks/useErrorCookie/useErrorCookie";
import TrackingInfoManager from "../../Utils/TrackingInfoManager";
import { EVALUATION_STATES, FLOW_TYPES, SELLER_STATE_COOKIE } from "../../Constants/evaluation";
import CTA from "../../Components/CTA/CTA";
import { MOBILE } from "../../Constants/platform";
import { HEIGHT_34, HEIGHT_58, WIDTH_34, WIDTH_58 } from "../../Constants/image";
export var UpagoSection = function UpagoSection(_ref) {
  var name = _ref.name,
    _ref$data = _ref.data,
    image = _ref$data.image,
    cta = _ref$data.cta,
    title = _ref$data.title,
    subtitle = _ref$data.subtitle,
    metadata = _ref.metadata,
    track = _ref.track,
    locationId = _ref.locationId,
    ReactObserver = _ref.ReactObserver,
    widgetKey = _ref.widgetKey,
    browsingMode = _ref.browsingMode,
    origin = _ref.origin;
  var _ref2 = metadata || {},
    style = _ref2.style;
  var PanameraConstants = DependencyManager.getDependency('constants');
  useErrorCookie({
    widgetName: name
  });
  var handleChange = useCallback(function (inView) {
    if (inView && track && metadata && metadata.trackingInfo && metadata.trackingInfo.impressionEvent && metadata.trackingInfo.impressionEvent.name) {
      var trackingInfo = TrackingInfoManager.getTrackingInfo({
        variants_shown: widgetKey,
        browsing_location_id: locationId || UNKNOWN,
        browsing_mode: browsingMode,
        origin: origin,
        select_from: metadata.trackingInfo.impressionEvent.selectFrom,
        reason: CookieManager.readCookie(SELLER_STATE_COOKIE) || EVALUATION_STATES.INITIAL,
        flow_type: FLOW_TYPES.NO_DRAFT
      });
      track(metadata.trackingInfo.impressionEvent.name, trackingInfo);
    }
  }, [browsingMode, locationId, origin, track, widgetKey, metadata]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, ReactObserver && /*#__PURE__*/React.createElement(ReactObserver, {
    as: 'div',
    onChange: handleChange,
    "data-aut-id": "observer"
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames(css.widget, css[PanameraConstants.platform]),
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: css.image
  }, /*#__PURE__*/React.createElement(StaticItem, {
    image: Object.assign(Object.assign({}, image), {
      width: PanameraConstants.platform == MOBILE ? WIDTH_34 : WIDTH_58,
      height: PanameraConstants.platform == MOBILE ? HEIGHT_34 : HEIGHT_58
    }),
    widgetName: name,
    locationId: locationId,
    track: track,
    ctaWrapperClassName: css.cta,
    metadata: metadata
  }), title && /*#__PURE__*/React.createElement("div", {
    className: css.imageTitle
  }, title === null || title === void 0 ? void 0 : title.text)), /*#__PURE__*/React.createElement("div", {
    className: css.body
  }, title && /*#__PURE__*/React.createElement("div", {
    className: css.title
  }, title === null || title === void 0 ? void 0 : title.text), subtitle && /*#__PURE__*/React.createElement("div", {
    className: css.subtitle
  }, subtitle.text)), cta && cta.buttons && cta.buttons.map(function (btn, idx) {
    var _a, _b;
    return /*#__PURE__*/React.createElement(CTA, {
      key: idx,
      widgetKey: name,
      button: btn,
      track: track,
      metadata: metadata,
      select_from: ((_b = (_a = metadata === null || metadata === void 0 ? void 0 : metadata.trackingInfo) === null || _a === void 0 ? void 0 : _a.clickEvent) === null || _b === void 0 ? void 0 : _b.selectFrom) || UserSession.getTabName(),
      customClass: css.actionCta
    });
  })));
};
export default compose(withComponentDependency, withRouter)(UpagoSection);